
const title = "Enterprise Name";
const text = `Through the company profile, the outside world can have a visual understanding of the company and showcase its style. When introducing, the key points should be highlighted, and praise words should be used appropriately to showcase the company's achievements in business operations.company profile, the outside world can have a visual understanding of the company and showcase its style. and showcase its style.`;
const dataInfo = [
  {
    title: "Technological Advantage",
    subTitle:
      "We utilize industry-leading continuous countercurrent extraction equipment for efficient, low-temperature processing that preserves the bioactivity of active ingredients, ensuring high purity and stability.",
    src: "/img/e1.webp",
  },
  {
    title: "Quality Assurance",
    subTitle:
      "Our production follows GMP standards and is certified with ISO 22000, Halal, and Kosher. Every batch is fully traceable from raw material to finished product, guaranteeing consistency.",
    src: "/img/e2.webp",
  },
  {
    title: "Diverse Product Portfolio",
    subTitle:
      "We specialize in Soy Isoflavones, Andrographolide, Knotweed Extract (Resveratrol) , and over 100 other botanical extracts, serving pharmaceutical, nutraceutical, and functional food industries.",
    src: "/img/e3.webp",
  },
  {
    title: "Customization Services",
    subTitle:
      "We offer OEM/ODM services with flexible specifications, concentrations, and packaging. Our professional R&D team responds quickly to market demands.",
    src: "/img/e4.webp",
  },
];
export default {
  props: {
    aboutUs: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      title,
      text,
      dataInfo,
    };
  },
};
